// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';

import Login from './pages/LoginPage';
import LogoutPage from './pages/LogoutPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import DashboardPage from './pages/DashboardPage';
import ActivitiesPage from './pages/ActivitiesPage';
import LeaderboardPage from './pages/LeaderboardPage';
import DiscussPage from './pages/DiscussPage';
import ProfilePage from './pages/ProfilePage';

import ProtectedRoute from './components/ProtectedRoute';
import GuestOnlyRoute from './components/GuestOnlyRoute';

import './App.css';

export default function App() {

  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route element={<GuestOnlyRoute redirectTo="/dashboard" />}>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<VerifyEmailPage />} />
          </Route>
          <Route path="/logout" element={<LogoutPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/activities" element={<ActivitiesPage />} />
            <Route path="/rank" element={<LeaderboardPage />} />
            <Route path="/discuss" element={<DiscussPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/profile/:userId" element={<ProfilePage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}
